import "babel-polyfill";
import "./libs/jcf";
import "./libs/jcf.select";
import "./libs/jcf.scrollable";

import {binder} from "./libs/binder";
import {commonFunction, constants} from "./modules/module";
import {footerNavigation} from "./modules/footer-navigation";
import {scrollToTop} from "./modules/scroll-to-top";
import {mobileNavigation} from "./modules/mobile-navigation";
import {subMenu} from "./modules/sub-menu";
import {customSelect} from "./modules/custom-select";
import {counter} from "./modules/counter";
import {popups} from "./modules/popups";
import {numbersSlider} from "./modules/numbers-slider";
import {teamSlider} from "./modules/team-slider-init";
import {differencesSlider} from "./modules/differences-slider";
import {scrollAnimate} from "./modules/scroll-animate";
import {wordsSlider} from "./modules/words-slider";
import {anchorScroll} from "./modules/anchor-scroll";
import {anchors} from "./modules/anchors";
import {asideFilter} from "./modules/aside-filter-expand";
import {testimonialsVirtualSlider} from "./modules/testimonials-virtual-slider";
import {testimonialsSlider} from "./modules/testimonials-slider";
import {howitworksSlider} from "./modules/howitworks-slider";
import {industriesSlider} from "./modules/industries-slider";
import {initAccordion} from "./modules/accordion";
import {listingFilterDropdown} from "./modules/listing-filter-dropdown";
import {logoSlider} from "./modules/logo-slider";
import {realizeSlider} from "./modules/realize-slider";
import {stickySidebar} from "./modules/sticky-sidebar";
import {playOnload} from "./modules/play-onload";
import {bodymovinHandler} from "./modules/bodymovin-handler";
// import {openJoinForm} from "./modules/open-join-form";
import {locationsHover} from "./modules/locations-hover";
import {customersTabs} from "./modules/our-customers-tabs";
import {filterBlock} from "./modules/filter-block";
import { querySelect } from "./modules/querySelect";
import { stickyHeader } from "./modules/stickyHeader";

binder({
    bounds: {
        "html": constants,
        "body": commonFunction,
        ".main-header": [mobileNavigation, subMenu, stickyHeader],
        ".main-footer": footerNavigation,
        ".scroll-to-top": scrollToTop,
        "select": customSelect,
        ".popups": popups,
        ".scrolled": scrollAnimate,
        ".numbers-slider": [counter, numbersSlider],
        ".industries-slider": industriesSlider,
        ".team-slider": teamSlider,
        ".differences": differencesSlider,
        ".testimonials-slider": testimonialsSlider,
        ".customer-stories-listing-slider-innit": testimonialsVirtualSlider,
        ".howitworks-slider": howitworksSlider,
        ".words-slider": wordsSlider,
        ".anchor-link": anchorScroll,
        ".use-cases": anchors,
        "#filters-wrapper": asideFilter,
        ".accordion": initAccordion,
        ".listing-filtration .expand-btn": listingFilterDropdown,
        ".logo-slider": logoSlider,
        ".realize-slider": realizeSlider,
        ".sticky-parent": stickySidebar,
        ".play-onload": playOnload,
        ".bodymovin": bodymovinHandler,
        ".our-locations": locationsHover,
        ".our-customers": customersTabs,
        ".filter-block": filterBlock,
        ".query-select": querySelect,
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js